import styled, { css } from 'styled-components'
import { mediaTabLand } from 'styles/media'

export const Container = styled.div`
    width: 300px;
    ${mediaTabLand(css`
        width: 200px;
    `)}
`